/**
 * @copyright 2026 @ DigiNet
 * @author ANHTAI
 * @create 2026/07/13 09:15
 * @update 2026/07/13 09:15
 */

import { Column, Summary, TotalItem } from "devextreme-react/data-grid";
import { ButtonIcon, Col, DatePicker, Dropdown, NumberInput, Row, Typography, Checkbox } from 'diginet-core-ui/components';
import { makeStyles } from "diginet-core-ui/theme";
import React, { useEffect, useMemo, useState, useRef } from 'react';
import { connect } from "react-redux";
import { browserHistory } from "react-router";
import { bindActionCreators } from "redux";
import * as userActions from "../../../actions/user-actions";
import * as W07F2010Actions from "../../../actions/w07/w07F2010/w07F2010-actions";
import * as W07F2020Actions from "../../../actions/w07/w07F2020/w07F2020-actions";
import Config from "../../../config";
import GridActionBar from "../../common/action-bar/grid-action-bar-hover";
import GridContainer from "../../common/grid-container/grid-container";
import ActionToolbar from "../../common/tool-bar/action-toolbar";
import ModalHistory from "./W07F2010ModalHistory";
import ButtonExport from "../../common/button/button-export";

const useStyles = makeStyles({
    moneyInputColumn: {
        width: '100%',
        margin: 0,
        '& input': {
            textAlign: 'right'
        }
    },
    ddColumn: {
        marginBottom: 0,
    }
});

const FormID = 'W07F2010';

const W07F2010 = (props) => {
    const classes = useStyles();
    const [iPermission, setIPermission] = useState(null);
    const [formLoading, setFormLoading] = useState(false);
    const [cboPeriodLoading, setCboPeriodLoading] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [cboWarehouseKXLoading, setCboWarehouseKXLoading] = useState(false);
    const [cboWarehouseKNLoading, setCboWarehouseKNLoading] = useState(false);
    const [loadingCbo, setLoadingCbo] = useState({});
    const [search, setSearch] = useState('');
    const [dataFilter, setDataFilter] = useState({
        DateFrom: null,
        DateTo: null,
        PeriodFrom: null,
        PeriodTo: null,
        WareHouseID: '',
        WareHouseID2: '',
        ReceiverID: "",
        EmployeeID: "",
        AStatusID: null,
        InventoryID: "",
        IsDetail: 0
    });
    const [dataGrid, setDataGrid] = useState([]);
    const [dataCboPeriodFrom, setDataCboPeriodFrom] = useState([]);
    const [dataCboPeriodTo, setDataCboPeriodTo] = useState([]);
    const [dataColumnGrid, setDataColumnGrid] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [dataCboWarehouseKX, setDataCboWarehouseKX] = useState([]);
    const [dataCboWarehouseKN, setDataCboWarehouseKN] = useState([]);
    const [dataSourceCbo, setDataSourceCbo] = useState({});

    const exportRef = useRef(null);

    useEffect(() => {
        loadPermission();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!iPermission) return;
        loadDynamicColumn();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [iPermission]);

    useEffect(() => {
        if (!iPermission) return;
        loadGrid();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [iPermission, dataFilter]);

    const loadPermission = () => {
        props.userActions.getPermission(Config.profile.UserID, FormID, (iPer) => {
            setIPermission(iPer)
        });
    };

    const renderColByType = (data) => {
        const { Width = 150, IsPermanent, Caption = '', FieldName = '', DataType = '', } = data || {};
        let colProps = {};
        if (DataType.includes('DECIMAL')) {
            colProps = {
                dataType: 'number',
                alignment: 'right',
                cellRender: (e) => <NumberInput
                    readOnly
                    nonStyle
                    disabledNegative
                    decimalDigit={4}
                    thousandSeparator={','}
                    value={e?.value}
                    className={classes.moneyInputColumn}
                />
            };

        } else if (DataType.includes('DATETIME')) {
            colProps = {
                alignment: 'center',
                dataType: 'date',
                format: 'dd/MM/yyyy HH:mm:ss'
            };

        } else if (DataType.includes('INT')) {
            colProps = {
                alignment: 'right',
                dataType: 'number',
            };
        }
        if (IsPermanent === 1) colProps = { ...colProps, fixed: true, fixedPosition: 'left' };
        if (FieldName.includes('Status')) colProps = { cellRender: (e) => <Typography color={e?.data?.StatusColor}>{e?.value}</Typography> };
        return <Column
            key={FieldName}
            width={Width}
            caption={Caption}
            dataField={FieldName}
            {...colProps}
        />
    };

    const loadDynamicColumn = (dataDetail) => {
        const params = getParamGeneral("Addcol", dataDetail);
        props.W07F2010Actions.loadDynamicColumn(params, (error, data) => {
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                const dataCol = data.map(item => renderColByType(item));
                setDataColumnGrid(dataCol);
            }
        });
    };

    const loadCombo = (type) => {
        const params = getParamGeneral(type);
        setLoadingCbo(prev => ({ ...prev, [type]: true }));
        props.W07F2010Actions.loadCombo(params, (error, data) => {
            setLoadingCbo(prev => ({ ...prev, [type]: false }));
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                const rawList = Array.isArray(data) ? data : (data?.data || []);
                setDataSourceCbo(prev => ({
                    ...prev,
                    [type]: rawList
                }));
            }
        });
    };

    const loadGrid = (searchText = "") => {
        const params = getParamGeneral('loadGrid', { StrSearch: searchText });
        setFormLoading(true);
        props.W07F2010Actions.loadGrid(params, (error, data) => {
            setFormLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                setDataGrid(data || []);
            }
        });
    };

    const loadCboWareHouse = (Type) => {
        if (Type === 'KX') setCboWarehouseKXLoading(true);
        else if (Type === 'KN') setCboWarehouseKNLoading(true);
        props.W07F2020Actions.loadComboWareHouse({ ...getParamGeneral(), Type }, (error, data) => {
            if (Type === 'KX') setCboWarehouseKXLoading(false);
            else if (Type === 'KN') setCboWarehouseKNLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                if (Type === 'KX') setDataCboWarehouseKX(data || []);
                else if (Type === 'KN') setDataCboWarehouseKN(data || []);
            }
        });
    };

    const onOpenLoaded = () => {
        loadCboPeriod();
        loadCombo("CmbEmployee");
        loadCombo("CmbReceiver");
        loadCombo("CmbStatus");
        loadCombo("CmbInventory");
        loadCboWareHouse('KX');
        loadCboWareHouse('KN');
    };

    const getParamGeneral = (type, data) => {
        const { RDVoucherID = '' } = data || {};
        let params = {
            DateFrom: null,
            DateTo: null,
            PeriodFrom: null,
            PeriodTo: null,
            RDVoucherID: '',
            StrSearch: search,
        };
        switch (type) {
            case 'loadGrid':
                params = { ...params, ...dataFilter, JsonData: "", Type: "", DataTypeID: "LoadForm", AStatusID: Number(dataFilter?.AStatusID || ""), StrSearch: data?.StrSearch || "" };
                break;
            case 'export':
                params = { ...params, ...dataFilter };
                break;
            case 'deleteRow':
            case 'checkEdit':
                params.RDVoucherID = RDVoucherID;
                break;
            case 'CmbReceiver':
            case 'CmbStatus':
            case 'CmbInventory':
            case 'CmbEmployee':
            case 'KN':
            case 'KX':
                params = { ...params, ...dataFilter, DataTypeID: "Search", Type: type, JsonData: "" };
                break;
            case 'Addcol':
                params = { ...params, ...dataFilter, IsDetail: data?.IsDetail ?? dataFilter?.IsDetail , DataTypeID: type, Type: "", JsonData: "" };
                break;
            default:
                break;
        }
        if (!Config.isEmpty(params?.PeriodFrom) && Config.typeOf(params?.PeriodFrom, 'string')) params.PeriodFrom = Number(params.PeriodFrom.replace(/\s/g, ""));
        if (!Config.isEmpty(params?.PeriodTo) && Config.typeOf(params?.PeriodTo, 'string')) params.PeriodTo = Number(params.PeriodTo.replace(/\s/g, ""));
        return params;
    };

    const loadCboPeriod = () => {
        const params = getParamGeneral();
        setCboPeriodLoading(true);
        props.W07F2010Actions.loadComboPeriod(params, (error, data) => {
            setCboPeriodLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                setDataCboPeriodFrom(data?.[0] || []);
                setDataCboPeriodTo(data?.[1] || []);
            }
        });
    };

    const checkEdit = (dataRow) => {
        const params = getParamGeneral('checkEdit', dataRow);
        setFormLoading(true);
        props.W07F2020Actions.checkEdit(params, (error, data) => {
            setFormLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                if (data?.Status === 0) handleRedirect('edit', dataRow);
                else if (data?.Status === 1 && data?.Message) Config.popupCore.show('WARNING', data.Message);
            }
        });
    };

    const onCloseModal = () => {
        setOpenModal(false);
    }

    const checkHistory = (dataRow) => {
        setSelectedRow(dataRow);
        setOpenModal(true);
    };

    const handleRedirect = (mode, dataRow = {}) => {
        browserHistory.push({
            pathname: Config.getRootPath() + 'W07F2020',
            state: {
                mode,
                ...dataRow
            }
        });
    };

    const deleteRow = (e) => {
        Config.popupCore.show('YES_NO', `${Config.lang('Ban_co_chac_chan_muon_xoa_du_lieu_nay')}`, () => {
            const params = getParamGeneral('deleteRow', e?.data);
            props.W07F2010Actions.onDeleteRow(params, (error, data) => {
                if (error) {
                    Config.popupCore.show('ERROR', error);
                    return false;
                } else if (data) {
                    if (data?.Status === 0) {
                        Config.notify.show('success', Config.lang('Du_lieu_da_xoa_thanh_cong'), 2000);
                        loadGrid();
                    } else if (data?.Message) {
                        Config.popupCore.show('WARNING', data.Message);
                    }
                }
            })
        })
    };

    const renderButtonAction = (e) => {
        if (!e) return null;
        return (
            <GridActionBar>
                <div className={"display_row align-center"}>
                    <ButtonIcon
                        circular
                        viewType={"text"}
                        name={"History"}
                        title={Config.lang('Lich_su')}
                        disabled={e?.data?.IsHistory !== 1}
                        onClick={() => checkHistory(e?.data)}
                    />
                    <ButtonIcon
                        circular
                        viewType={"text"}
                        name={"Edit"}
                        title={Config.lang('Sua')}
                        disabled={iPermission <= 2}
                        onClick={() => checkEdit(e?.data)}
                    />
                    <ButtonIcon
                        circular
                        viewType={"text"}
                        name={"Delete"}
                        title={Config.lang('Xoa')}
                        disabled={iPermission <= 3}
                        onClick={() => deleteRow(e)}
                    />
                </div>
            </GridActionBar>
        )
    };

    const btnCRM = [
        {
            buttonName: Config.lang("Xuat_du_lieu"),
            buttonType: 'button',
            icon: 'Sheet',
            color: 'Success',
            align: 'right',
            disabled: false,
            onClick: () => {
                if (exportRef.current.getWrappedInstance().onClick) {
                exportRef.current.getWrappedInstance().onClick("0")
            }
            }
            
        }];

    const onSearch = (text = '') => {
        setSearch(text);
        loadGrid(text);
    };

    const onChangeFilter = (keyName, e) => {
        if (!e || !keyName) return;
        let value = e?.value ?? e?.target?.value ?? '';
        if (Config.isEmpty(value) && ['DateFrom', 'DateTo', 'PeriodFrom', 'PeriodTo'].includes(keyName)) value = null;
        let objPlus = { ...dataFilter, [keyName]: value };
        switch (keyName) {
            case "IsDetail":
                objPlus.IsDetail = +value;
                loadDynamicColumn({...dataFilter, IsDetail: +value});
                break;
            default:
                break;
        }
        setDataFilter(objPlus);
    };

    const filterRender = () => {
        return <Row>
            <Col xs={12} sm={12} md={6} lg={6}>
                <Row>
                    <Col xs={12} sm={6}>
                        <div className={"display_row align-center"}>
                            <Typography className="mgr4x" type='h4' color={"label"} style={{ whiteSpace: 'nowrap' }}>{Config.lang("Ngay_phieu")}</Typography>
                            <DatePicker
                                clearAble
                                viewType={'outlined'}
                                displayFormat={"DD/MM/YYYY"}
                                placeholder={Config.lang('Tu')}
                                max={dataFilter?.DateTo}
                                value={dataFilter?.DateFrom}
                                className={'full_w'}
                                onChange={e => onChangeFilter('DateFrom', e)}
                            />
                            <div className={'pdl4x'}>-</div>
                        </div>
                    </Col>
                    <Col xs={12} sm={6}>
                        <DatePicker
                            clearAble
                            viewType={'outlined'}
                            displayFormat={"DD/MM/YYYY"}
                            placeholder={Config.lang('Den')}
                            min={dataFilter?.DateFrom}
                            value={dataFilter?.DateTo}
                            onChange={e => onChangeFilter('DateTo', e)}
                        />
                    </Col>
                </Row>
            </Col>
            <Col xs={12} sm={12} md={6} lg={6}>
                <Row>
                    <Col xs={12} sm={6}>
                        <div className={"display_row align-center"}>
                            <Typography className="mgr4x" type='h4' color={"label"} style={{ whiteSpace: 'nowrap' }}>{Config.lang("Ky")}</Typography>
                            <Dropdown
                                clearAble
                                required
                                style={{ backgroundColor: "white" }}
                                viewType={'outlined'}
                                valueExpr={'PeriodFrom'}
                                displayExpr={'PeriodFrom'}
                                loading={cboPeriodLoading}
                                dataSource={dataCboPeriodFrom}
                                placeholder={Config.lang('Tu')}
                                value={dataFilter?.PeriodFrom}
                                className={'full_w'}
                                onChange={e => onChangeFilter('PeriodFrom', e)}
                            />
                            <div className={'pdl4x'}>-</div>
                        </div>
                    </Col>
                    <Col xs={12} sm={6}>
                        <Dropdown
                            clearAble
                            required
                            style={{ backgroundColor: "white" }}
                            viewType={'outlined'}
                            valueExpr={'PeriodTo'}
                            displayExpr={'PeriodTo'}
                            loading={cboPeriodLoading}
                            dataSource={dataCboPeriodTo}
                            placeholder={Config.lang('Den')}
                            value={dataFilter?.PeriodTo}
                            onChange={e => onChangeFilter('PeriodTo', e)}
                        />
                    </Col>
                </Row>
            </Col>
            <Col xs={12} sm={12} md={6}>
                <Row>
                    <Col xs={12} sm={12} md={6} lg={6}>
                        <Row className={"display_row align-center"}>
                            <Col xs={12} sm={3}>
                                <Typography className="mgr4x" type='h4' color={"label"} style={{ whiteSpace: 'nowrap' }}>{Config.lang("Kho_xuat")}</Typography>
                            </Col>
                            <Col xs={12} sm={9}>
                                <Dropdown
                                    clearAble
                                    style={{ backgroundColor: "white" }}
                                    viewType={'outlined'}
                                    valueExpr={'WareHouseID'}
                                    displayExpr={'WareHouseName'}
                                    loading={cboWarehouseKXLoading}
                                    dataSource={dataCboWarehouseKX}
                                    value={dataFilter?.WareHouseID2}
                                    onChange={e => onChangeFilter('WareHouseID2', e)}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={12} sm={12} md={6} lg={6}>
                        <Row className={"display_row align-center"}>
                            <Col xs={12} sm={3}>
                                <Typography className="mgr4x" type='h4' color={"label"} style={{ whiteSpace: 'nowrap' }}>{Config.lang("Kho_nhap")}</Typography>
                            </Col>
                            <Col xs={12} sm={9}>
                                <Dropdown
                                    clearAble
                                    style={{ backgroundColor: "white" }}
                                    viewType={'outlined'}
                                    valueExpr={'WareHouseID'}
                                    displayExpr={'WareHouseName'}
                                    loading={cboWarehouseKNLoading}
                                    dataSource={dataCboWarehouseKN}
                                    value={dataFilter?.WareHouseID}
                                    onChange={e => onChangeFilter('WareHouseID', e)}
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col>
            <Col xs={12} sm={12} md={6}>
                <Row>
                    <Col xs={12} sm={12} md={6} lg={6}>
                        <Row className={"display_row align-center"}>
                            <Col xs={12} sm={3}>
                                <Typography className="mgr4x" type='h4' color={"label"} style={{ whiteSpace: 'nowrap' }}>{Config.lang("Nguoi_lap")}</Typography>
                            </Col>
                            <Col xs={12} sm={9}>
                                <Dropdown
                                    clearAble
                                    style={{ backgroundColor: "white" }}
                                    viewType={'outlined'}
                                    valueExpr={'EmployeeID'}
                                    displayExpr={'EmployeeName'}
                                    loading={loadingCbo['CmbEmployee']}
                                    dataSource={dataSourceCbo['CmbEmployee']}
                                    value={dataFilter?.EmployeeID}
                                    onChange={e => onChangeFilter('EmployeeID', e)}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={12} sm={12} md={6} lg={6}>
                        <Row className={"display_row align-center"}>
                            <Col xs={12} sm={3}>
                                <Typography className="mgr4x" type='h4' color={"label"} style={{ whiteSpace: 'nowrap' }}>{Config.lang("Nguoi_nhan")}</Typography>
                            </Col>
                            <Col xs={12} sm={9}>
                                <Dropdown
                                    clearAble
                                    style={{ backgroundColor: "white" }}
                                    viewType={'outlined'}
                                    valueExpr={'ReceiverID'}
                                    displayExpr={'ReceiverName'}
                                    loading={loadingCbo['CmbReceiver']}
                                    dataSource={dataSourceCbo['CmbReceiver']}
                                    value={dataFilter?.ReceiverID}
                                    onChange={e => onChangeFilter('ReceiverID', e)}
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col>
            <Col xs={12} sm={12} md={6}>
                <Row>
                    <Col xs={12} sm={12} md={6} lg={6}>
                        <Row className={"display_row align-center"}>
                            <Col xs={12} sm={3}>
                                <Typography className="mgr4x" type='h4' color={"label"} style={{ whiteSpace: 'nowrap' }}>{Config.lang("Trang_thai")}</Typography>
                            </Col>
                            <Col xs={12} sm={9}>
                                <Dropdown
                                    clearAble
                                    style={{ backgroundColor: "white" }}
                                    viewType={'outlined'}
                                    valueExpr={'AStatusID'}
                                    displayExpr={'StatusName'}
                                    loading={loadingCbo['CmbStatus']}
                                    dataSource={dataSourceCbo['CmbStatus']}
                                    value={dataFilter?.AStatusID}
                                    onChange={e => onChangeFilter('AStatusID', e)}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={12} sm={12} md={6} lg={6}>
                        <Row className={"display_row align-center"}>
                            <Col xs={12} sm={3}>
                                <Typography className="mgr4x" type='h4' color={"label"} style={{ whiteSpace: 'nowrap' }}>{Config.lang("Mat_hang")}</Typography>
                            </Col>
                            <Col xs={12} sm={9}>
                                <Dropdown
                                    clearAble
                                    style={{ backgroundColor: "white" }}
                                    viewType={'outlined'}
                                    valueExpr={'InventoryID'}
                                    displayExpr={'InventoryName'}
                                    loading={loadingCbo['CmbInventory']}
                                    dataSource={dataSourceCbo['CmbInventory']}
                                    value={dataFilter?.InventoryID}
                                    onChange={e => onChangeFilter('InventoryID', e)}
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col>
            <Col xs={12} sm={12} md={6} className={"display_row align-center"}>
                <Checkbox
                    label={Config.lang("Hien_thi_chi_tiet")}
                    className={'flex valign-middle'}
                    checked={!!dataFilter?.IsDetail}
                    onChange={e => onChangeFilter('IsDetail', e)}
                />
            </Col>
        </Row>
    };

    const renderGrid = useMemo(() => {
        return (
            <GridContainer
                isShowFilter
                dataSource={dataGrid}
                onAddNew={() => handleRedirect('add')}
                onDbCellClick={(e) => handleRedirect('view', e?.data)}
                isPer={iPermission}
                buttonCRM={btnCRM}
                loading={formLoading}
                typePaging={'normal'}
                keyExpr={'RDVoucherID'}
                pagerFullScreen
                itemPerPage={20}
                listPerPage={[20, 40, 60, 80]}
                elementAttr={{ style: `height: ${Config.getHeightGrid() - 86}px` }}
                valueSearch={search}
                onSearch={onSearch}
                filterRender={filterRender()}
                onOpenLoaded={onOpenLoaded}  >
                <Column
                    caption={Config.lang("Hanh_dong")}
                    visible={Config.isMobile}
                    alignment={"center"}
                    allowEditing={false}
                    cellRender={e => renderButtonAction(e)}
                />
                {dataColumnGrid}
                <Column
                    fixed
                    minWidth={90}
                    fixedPosition={"right"}
                    visible={!Config.isMobile}
                    cellRender={e => renderButtonAction(e)}
                />
                <Summary>
                    <TotalItem
                        column={'ActualQuantity'} // So luong
                        summaryType={'sum'}
                        displayFormat={"{0}"}
                        valueFormat={(e) => Config.numberFormat(e, 8)}
                    />
                </Summary>
            </GridContainer>
        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [iPermission, dataGrid, formLoading, dataCboPeriodFrom, dataCboPeriodTo, cboPeriodLoading, dataColumnGrid, loadingCbo, cboWarehouseKNLoading, cboWarehouseKXLoading]);

    const paramExport = [
        { id: "UserID", type: "Varchar", value: Config.profile.UserID },
        { id: "Language", type: "Varchar", value: Config.language || '84' },
        { id: "DivisionID", type: "VarChar", value: Config.profile.DivisionID || "" },
        { id: "InventoryID", type: "VarChar", value: dataFilter?.InventoryID },
        { id: "AStatusID", type: "TINYINT", value: Config.isEmpty(dataFilter?.AStatusID) ? 0 : dataFilter?.AStatusID},
        { id: "DateFrom", type: "DATETIME", value: dataFilter?.DateFrom },
        { id: "DateTo", type: "DATETIME", value: dataFilter?.DateTo },
        { id: "IsDetail", type: "TINYINT", value: dataFilter?.IsDetail },
        { id: "PeriodFrom", type: "DATETIME", value: dataFilter?.PeriodFrom },
        { id: "PeriodTo", type: "DATETIME", value: dataFilter?.PeriodTo },
        { id: "WareHouseID", type: "VarChar", value: dataFilter?.WareHouseID },
        { id: "WareHouseID2", type: "VarChar", value: dataFilter?.WareHouseID2 },
        { id: "ReceiverID", type: "VarChar", value: dataFilter?.ReceiverID },
        { id: "EmployeeID", type: "VarChar", value: dataFilter?.EmployeeID },
        { id: "StrSearch", type: "VarChar", value: dataFilter?.StrSearch || "" },
    ];

    if (!iPermission) return null;
    return (
        <>
            {openModal &&
                <ModalHistory
                    open={openModal}
                    onClose={onCloseModal}
                    dataRow={selectedRow}
                />
            }
            <ButtonExport
                className={"hide"}
                ref={ref => exportRef.current = ref}
                reportTypeID={FormID}
                id={'slave1'}
                name={Config.lang('In1')}
                onlyShowPopup
                param={paramExport}
            />
            <div className={'page-container-new'} style={{ height: '100vh' }}>
                <ActionToolbar title={Config.lang("Danh_sach_phieu_dieu_chuyen_noi_bo")} />
                <Row><Col xs={12}>{renderGrid}</Col></Row>
            </div>
        </>
    );
}

export default connect(null, (dispatch) => ({
    W07F2010Actions: bindActionCreators(W07F2010Actions, dispatch),
    W07F2020Actions: bindActionCreators(W07F2020Actions, dispatch),
    userActions: bindActionCreators(userActions, dispatch),
}))(W07F2010);


